var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_25",
    "data-name": "Group 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 362,
    height: 368.049,
    viewBox: "0 0 362 368.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 362,
    height: 368.049,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 31.851,
    height: 31.825,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M78.025,628.76a5.909,5.909,0,1,0,5.918-5.918,5.917,5.917,0,0,0-5.918,5.918",
    transform: "translate(-34.011 -271.499)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M147.57,628.76a5.909,5.909,0,1,0,5.918-5.918,5.917,5.917,0,0,0-5.918,5.918",
    transform: "translate(-64.326 -271.499)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M217.116,628.76a5.909,5.909,0,1,0,5.918-5.918,5.917,5.917,0,0,0-5.918,5.918",
    transform: "translate(-94.642 -271.499)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M72.99,264.713,99.18,390.8a8.06,8.06,0,0,0,7.932,6.439h41.281l.313-12.558-39.349,0-11-39.18s3.732-34.489-7.566-49.86c0,0,4.012-30.366-17.8-30.928",
    transform: "translate(-31.817 -115.39)",
    fill: "#3b3f4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M163.807,295.663s4-30.387-17.809-30.925H73.006c21.814.539,17.809,30.925,17.809,30.925,11.3,15.35,7.54,49.851,7.54,49.851l11,39.187,39.359,0-.312,12.54h72.991l.313-12.54H183.912l-12.535-39.182",
    transform: "translate(-31.824 -115.4)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 66.189,
    height: 12.812,
    transform: "translate(116.477 269.024)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 12.64,
    height: 62.697,
    transform: "translate(82.832 281.836)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M64.819,614.527v7.658H170v-7.658a3.757,3.757,0,0,0-3.757-3.757H68.576a3.757,3.757,0,0,0-3.757,3.757",
    transform: "translate(-28.255 -266.237)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M167.529,227.639h-6.216a4.06,4.06,0,0,1-3.986-3.251c-1.907-9.4-5.674-36.067,12.459-37.923,22.043-2.257,24.976,13.079,20.125,22.2Z",
    transform: "translate(-67.848 -81.183)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M340.947,610.779a1.358,1.358,0,0,0-1.341,1.108,54.422,54.422,0,0,0-.949,7.66,9.438,9.438,0,0,0,1.01,4.841h31.224a4.515,4.515,0,0,0-4.8-4.917,6.109,6.109,0,0,1-2.061-.443c-3.623-1.409-7.357-5.816-8.855-7.729a1.352,1.352,0,0,0-1.072-.521Z",
    transform: "translate(-147.62 -266.241)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M383,627.382a5.655,5.655,0,0,0,1.12,3.382h6.1a4.515,4.515,0,0,0-4.8-4.917,6.112,6.112,0,0,1-2.061-.442,5.514,5.514,0,0,0-.359,1.978",
    transform: "translate(-166.953 -272.616)",
    fill: "#5e6f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M355.025,606.545H343.146l-.833-5.468a7.744,7.744,0,0,0,2.72.486h8.438a1.981,1.981,0,0,0,.583-.083Z",
    transform: "translate(-149.216 -262.012)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M199.981,448.2c20.13.175,41.12.462,46.573.549.886,0,1.361.012,1.361.012l20.429,65.018a8.02,8.02,0,0,0,7.688,5.691h8.436a2.183,2.183,0,0,0,2.159-2.5l-.7-4.7-15.4-81.142a14.364,14.364,0,0,0-12.978-12.192l-35.667-3.008-36.078-3.17a.182.182,0,0,0-.012.075c-.063.249-.262,1.048-.512,2.271-1.56,7.875-4.992,32.9,14.7,33.1",
    transform: "translate(-80.216 -179.924)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M199.981,450.016c20.13.175,41.12.462,46.573.549l-3.32-17.621a14.4,14.4,0,0,0-12.991-12.192l-35.654-3.008-9.31-.824c-1.56,7.875-4.992,32.9,14.7,33.1",
    transform: "translate(-80.216 -181.737)",
    fill: "#43a848"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M233.575,519.472h-8.442a8.036,8.036,0,0,1-7.685-5.692l-20.429-65.019s-24.54-.358-47.926-.564c-20.2-.192-16.085-26.479-14.586-33.656.247-1.127.412-1.787.412-1.787l36.075,3.176,35.649,3.011a14.377,14.377,0,0,1,12.992,12.181l15.81,84.033.275,1.815a2.173,2.173,0,0,1-2.144,2.5",
    transform: "translate(-58.03 -179.922)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M131.2,350.941c31.7,11.606,30.126-2.421,56.944,1.7-1.6-30.612-3.207-61.274-5.479-75.7a10.666,10.666,0,0,0-2.658-1.922,34.169,34.169,0,0,0-14.426-4.605l-12.492-1.16s-17.384,2.646-21.677,7.338c-9.4,10.246-.212,74.353-.212,74.353",
    transform: "translate(-55.439 -117.367)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M186.9,236.492V256.2l-.451,32.252L174.4,254.972v-18.48Z",
    transform: "translate(-76.022 -103.088)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M125.109,294.667l-5.652,30.825a9.944,9.944,0,0,0,4.725,9.837c9.228,5.552,27.9,14.133,38.547,20.014a4.809,4.809,0,0,1-.107-5.886c2.175-3.307,5.721-5.986,7.928-5.986a1.628,1.628,0,0,1,.356.033L138.47,324.974l4.8-20.366",
    transform: "translate(-52.034 -128.447)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M195.314,387.17c-2.173,3.306-.208,6.822,2,6.822s3.823-3.516,6-6.822,2.142-5.988-.067-5.988-5.758,2.682-7.93,5.988",
    transform: "translate(-84.727 -166.159)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M189.289,285.193l-.342,24.486-8.809-24.486Z",
    transform: "translate(-78.523 -124.317)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M290.05,610.779a1.358,1.358,0,0,0-1.341,1.108,54.435,54.435,0,0,0-.949,7.66,9.438,9.438,0,0,0,1.01,4.841h31.224a4.515,4.515,0,0,0-4.8-4.917,6.109,6.109,0,0,1-2.061-.443c-3.623-1.409-7.357-5.816-8.855-7.729a1.352,1.352,0,0,0-1.072-.521Z",
    transform: "translate(-125.434 -266.241)",
    fill: "#001428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M287.76,626.211a9.438,9.438,0,0,0,1.01,4.841h5.312a5.12,5.12,0,0,0-5.118-4.986,4.964,4.964,0,0,0-1.2.145",
    transform: "translate(-125.434 -272.905)",
    fill: "#5e6f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M332.106,627.382a5.655,5.655,0,0,0,1.12,3.382h6.1a4.515,4.515,0,0,0-4.8-4.917,6.106,6.106,0,0,1-2.061-.442,5.514,5.514,0,0,0-.36,1.978",
    transform: "translate(-144.766 -272.616)",
    fill: "#5e6f8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M304.129,606.545H292.25l-.833-5.468a7.741,7.741,0,0,0,2.72.486h8.439a1.98,1.98,0,0,0,.582-.083Z",
    transform: "translate(-127.03 -262.012)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M217.827,374.589c4.262-.437,3.834,3.008-1.161,3.971,11.362.3,12.872,4.307,5.713,4.308,0,0,5.446,3.3-.063,3.9,0,0,4.3,3.613-.863,3.215,5.215,4.712-8.67,5.015-17.068-.962l-9.791-2.85c.6-2.972,3.794-5.984,7.779-7.982Z",
    transform: "translate(-84.824 -163.268)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M239.878,388.5a.228.228,0,0,1-.061-.005l-4.852-1.109a.291.291,0,0,1-.219-.346.314.314,0,0,1,.342-.216l4.852,1.109a.287.287,0,0,1-.062.567",
    transform: "translate(-102.324 -168.618)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M239.365,395.337a.205.205,0,0,1-.061-.006l-4.847-1.109a.29.29,0,0,1-.219-.345.312.312,0,0,1,.342-.217l4.846,1.109a.287.287,0,0,1-.061.567",
    transform: "translate(-102.102 -171.595)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M238.287,401.087a.55.55,0,0,1-.068-.006l-4.785-1.146a.3.3,0,0,1-.213-.348.313.313,0,0,1,.348-.214l4.785,1.146a.3.3,0,0,1,.214.349.291.291,0,0,1-.281.219",
    transform: "translate(-101.659 -174.088)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M193.381,219.649c0,9.161-5.454,16.584-12.179,16.584-5.234,0-9.695-4.495-11.42-10.8a6.253,6.253,0,0,1-1.087.089c-2.929,0-5.3-1.854-5.3-4.147a4.249,4.249,0,0,1,3.182-3.8c13.212-1.143,19.444-6.835,22.236-10.865a19.272,19.272,0,0,1,4.571,12.945",
    transform: "translate(-71.224 -90.103)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M162.569,215a2.013,2.013,0,0,1-.073-4.024c21.442-.764,25.092-13.156,25.238-13.68a2.031,2.031,0,0,1,2.459-1.418,2.008,2.008,0,0,1,1.432,2.446c-.169.643-4.4,15.8-28.984,16.674a.672.672,0,0,1-.073,0",
    transform: "translate(-69.988 -85.354)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M188.343,228.057c-2.982,0-5.4-3.53-5.4-7.871s2.421-7.879,5.4-7.879,5.408,3.536,5.408,7.879-2.426,7.871-5.408,7.871m0-15.177c-2.662,0-4.83,3.277-4.83,7.306s2.168,7.3,4.83,7.3,4.835-3.274,4.835-7.3-2.168-7.306-4.835-7.306",
    transform: "translate(-79.744 -92.546)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M213.86,230.071c-2.982,0-5.4-3.53-5.4-7.868s2.421-7.879,5.4-7.879,5.408,3.535,5.408,7.879-2.426,7.868-5.408,7.868m0-15.174c-2.662,0-4.83,3.277-4.83,7.306s2.168,7.3,4.83,7.3,4.835-3.274,4.835-7.3-2.168-7.306-4.835-7.306",
    transform: "translate(-90.867 -93.425)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M205.532,226.5h-.011l-4.156-.155a.286.286,0,0,1,.011-.573h.011l4.156.155a.286.286,0,0,1-.011.573",
    transform: "translate(-87.656 -98.413)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M204.509,235.341c-.112,0-.219-.006-.337-.017l-.253-.031a2.3,2.3,0,0,0-.961.006.287.287,0,1,1-.179-.544,2.606,2.606,0,0,1,1.213-.031l.236.028a1.131,1.131,0,0,0,1.016-.225c.292-.323.152-.909-.028-1.44-.365-1.084-.685-2.2-.949-3.316a.294.294,0,0,1,.213-.348.284.284,0,0,1,.348.213c.258,1.1.573,2.2.938,3.268.146.455.461,1.4-.1,2.01a1.512,1.512,0,0,1-1.163.427",
    transform: "translate(-88.306 -100)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M200.767,246.988a5.833,5.833,0,0,1-4.19-1.811.283.283,0,0,1,.011-.407.287.287,0,0,1,.4.014,5.265,5.265,0,0,0,3.774,1.631h.017a.287.287,0,1,1,0,.573Z",
    transform: "translate(-85.654 -106.663)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M197.12,229.5c0,.738-.384,1.342-.844,1.342s-.853-.6-.853-1.342.383-1.343.853-1.343.844.6.844,1.343",
    transform: "translate(-85.186 -99.457)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M212.887,230.339c0,.738-.384,1.343-.844,1.343s-.853-.6-.853-1.343.384-1.343.853-1.343.844.6.844,1.343",
    transform: "translate(-92.059 -99.82)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M191.569,222.971a.284.284,0,0,1-.2-.081.293.293,0,0,1-.005-.407c.022-.023,2-1.994,4.122-.424a.285.285,0,0,1,.062.4.282.282,0,0,1-.4.059,2.588,2.588,0,0,0-3.37.368.3.3,0,0,1-.208.084",
    transform: "translate(-83.38 -96.532)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M210.585,221.828a.288.288,0,0,1-.208-.489,2.7,2.7,0,0,1,3.538-.365.289.289,0,0,1,.056.4.285.285,0,0,1-.4.059,2.151,2.151,0,0,0-2.78.309.285.285,0,0,1-.2.084",
    transform: "translate(-91.67 -96.099)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 266.468,
    height: 14.744,
    transform: "translate(95.532 237.539)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 81.434,
    height: 14.744,
    transform: "translate(14.098 237.539)",
    fill: "#b6bab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M332.581,414.362v3.1h-97.26v-3.1a1.612,1.612,0,0,1,1.613-1.607h94.04a1.606,1.606,0,0,1,1.607,1.607",
    transform: "translate(-102.577 -179.922)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M220.19,271.359l16.006,7.767,27.939-17.788,7.742,8.958s-21.3,23.941-31.4,25.9c-2.762.536-17.244-6.977-17.244-6.977",
    transform: "translate(-95.982 -113.918)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M304.629,270.649a2.8,2.8,0,0,1-1.67-.294.263.263,0,0,1-.089-.036,5.594,5.594,0,0,1-1.687-1.41,15.024,15.024,0,0,1-3.393-5.473s-.036-.116-.08-.285c-.018-.081-.045-.17-.063-.277a2.131,2.131,0,0,1,.134-1.714,1.567,1.567,0,0,1,1.143-.339c.089,0,.188.009.277.018,1.491.134,3.786,1.214,5.384,4.232a13.746,13.746,0,0,1,.973,2.179,1.864,1.864,0,0,1,.063.205c.75,2.428-.25,3.08-.991,3.2",
    transform: "translate(-129.697 -113.692)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M316.679,247.467a14.42,14.42,0,0,1-1.938,1.812c-1.839,1.4-5.865,4.375-7.99,5.143-.367.348-.715.687-1.045,1.027-.151.143-.294.294-.437.437q-1.218,1.232-2.223,2.465a.266.266,0,0,1-.09-.036,5.6,5.6,0,0,1-1.687-1.41,15.006,15.006,0,0,1-3.392-5.473s-.037-.116-.081-.285c-.017-.081-.045-.17-.063-.277.294-.437.642-.982,1-1.571.1-.161.188-.322.277-.482a12.79,12.79,0,0,0,1.821-4.464c.277-2.767.438-8.883,2.232-8.428s3.241,4.178,2.786,6.91c0,0,5.279-4.252,6.217-8.064,0,0,.54-2.336,1.947-1.154.432.362.006,4.577-.753,5.692a39.407,39.407,0,0,0,2.67-3.554c.419-.812,2.125-.526,1.339,2.357l.009-.009c.125-.054,1.036-.518,1.544,0,.625.652-.348,2.607-.438,2.776a1.03,1.03,0,0,1,1.429.134c1.187,1.169-1.572,4.661-3.134,6.455",
    transform: "translate(-129.783 -101.688)",
    fill: "#88c9a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M309.318,254.325a.287.287,0,0,1-.186-.065.29.29,0,0,1-.033-.4,9.736,9.736,0,0,0,1.381-3.906.289.289,0,0,1,.325-.245.286.286,0,0,1,.247.323,10.189,10.189,0,0,1-1.516,4.192.274.274,0,0,1-.219.1",
    transform: "translate(-134.708 -108.845)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M326.678,245.338a.287.287,0,0,1-.186-.505,20.82,20.82,0,0,0,3.039-3.389.288.288,0,0,1,.472.331,21.05,21.05,0,0,1-3.14,3.5.277.277,0,0,1-.185.068",
    transform: "translate(-142.275 -105.193)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M328.38,250.019a.287.287,0,0,1-.174-.514,32.022,32.022,0,0,0,3.19-3.15.283.283,0,0,1,.4-.025.289.289,0,0,1,.023.407,31.051,31.051,0,0,1-3.268,3.223.284.284,0,0,1-.174.059",
    transform: "translate(-143.017 -107.344)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M362.8,300.7a10.1,10.1,0,0,0,10.1,10.577h5.916A10.09,10.09,0,0,1,368.733,300.7l3.509-74.132a10.11,10.11,0,0,1,10.1-9.628h-5.916a10.109,10.109,0,0,0-10.1,9.628Z",
    transform: "translate(-158.143 -94.566)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M367.184,300.7a10.1,10.1,0,0,0,10.1,10.577h3.445A10.09,10.09,0,0,1,370.642,300.7l3.509-74.132a10.11,10.11,0,0,1,10.1-9.628H380.8a10.109,10.109,0,0,0-10.1,9.628Z",
    transform: "translate(-160.052 -94.566)",
    fill: "#50ad53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M508.673,227.524l-3.518,74.133a10.105,10.105,0,0,1-10.094,9.625H383.4A10.1,10.1,0,0,1,373.3,300.7l3.517-74.133a10.11,10.11,0,0,1,10.094-9.63H498.579a10.1,10.1,0,0,1,10.094,10.59",
    transform: "translate(-162.719 -94.562)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M401.853,307.9h96.957a4.059,4.059,0,0,0,4.055-3.867l2.681-56.393a4.06,4.06,0,0,0-4.055-4.253H404.534a4.06,4.06,0,0,0-4.055,3.867L397.8,303.643a4.06,4.06,0,0,0,4.055,4.253",
    transform: "translate(-173.4 -106.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M431.043,362.246l25.735-5.035-3.488-59.684c-.244-3.38,3.789-6.522,7.18-6.522h9.878v73.384h-40.5v-.69a1.479,1.479,0,0,1,1.2-1.454",
    transform: "translate(-187.371 -126.85)",
    fill: "#b6bab6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M477.608,294.435l4.455,69.874H504.2L499.594,292.4a1,1,0,0,0-.026-.195c-.248-.784-.634-1.335-1.322-1.374-.052,0-.091-.013-.143-.013H480.952a3.356,3.356,0,0,0-3.345,3.617",
    transform: "translate(-208.187 -126.769)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M492.7,312.362l2.858,35.227a4.068,4.068,0,0,0,3.973,3.68,3.348,3.348,0,0,0,3.374-3.68l-2.872-35.227a4.016,4.016,0,0,0-3.945-3.68,3.343,3.343,0,0,0-3.387,3.68",
    transform: "translate(-214.763 -134.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M499.042,264.631H456.681a.286.286,0,1,1,0-.573h42.361a.286.286,0,1,1,0,.573",
    transform: "translate(-198.944 -115.104)",
    fill: "#2d3240"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M167.524,387.729l-38.079-15.566-.393-4.355Z",
    transform: "translate(-56.254 -160.329)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M386.676,11.756l-4.2,82.779a10.816,10.816,0,0,1-10.711,10.173H262.039l-20.72,16.862,1.089-16.862H220.332a9.589,9.589,0,0,1-9.675-10.173l4.29-84.349A10.816,10.816,0,0,1,225.657.013H377.087c5.623,0,9.887,6.12,9.59,11.743",
    transform: "translate(-91.82 -0.006)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M217.783,15.55l.448-8.849A7.137,7.137,0,0,1,225.282,0h158.4a6.307,6.307,0,0,1,6.361,6.7l-.448,8.849Z",
    transform: "translate(-94.933)",
    fill: "#dbdfdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M497.917,11.7a2.525,2.525,0,0,0,2.556,2.692,2.847,2.847,0,0,0,2.8-2.692,2.515,2.515,0,0,0-2.528-2.673,2.848,2.848,0,0,0-2.828,2.673",
    transform: "translate(-217.043 -3.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M476.53,11.7a2.525,2.525,0,0,0,2.556,2.692,2.847,2.847,0,0,0,2.8-2.692,2.515,2.515,0,0,0-2.528-2.673A2.848,2.848,0,0,0,476.53,11.7",
    transform: "translate(-207.72 -3.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M456.587,11.7a2.525,2.525,0,0,0,2.556,2.692,2.847,2.847,0,0,0,2.8-2.692,2.515,2.515,0,0,0-2.528-2.673,2.848,2.848,0,0,0-2.828,2.673",
    transform: "translate(-199.027 -3.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M300.993,11.6l0,.173a2.778,2.778,0,0,1-2.718,2.6H232.388a2.427,2.427,0,0,1-2.447-2.6,2.745,2.745,0,0,1,2.7-2.583h65.891a2.439,2.439,0,0,1,2.462,2.41",
    transform: "translate(-100.23 -4.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(87.021 183.232)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M186.119,356.65c-12.3-6.291-24.574-13.422-27.117-14.849a8.382,8.382,0,0,1-4.31-4.721c-1.13-2.868.14-5.995,2.122-12.254-1.293,8.229-2.088,9.592-1.158,11.913a7.288,7.288,0,0,0,3.9,4.1c1.448.842,14.731,8.307,26.565,15.816",
    transform: "translate(-154.267 -324.825)",
    fill: "#b6bab6"
  })))))), /*#__PURE__*/React.createElement("text", {
    id: "New_Password",
    "data-name": "New Password",
    transform: "translate(147.689 88.338)",
    fill: "#70b971",
    fontSize: 15,
    fontFamily: "Ubuntu-MediumItalic, Ubuntu",
    fontWeight: 500,
    fontStyle: "italic"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Passwo"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.006em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "d")), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M357.748,121.674H320.313a3.692,3.692,0,0,1-3.728-3.968,4.273,4.273,0,0,1,4.208-3.968h37.435a3.693,3.693,0,0,1,3.728,3.968,4.272,4.272,0,0,1-4.208,3.968",
    transform: "translate(-137.998 -49.579)",
    fill: "#56af5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M343.842,119.621a1.615,1.615,0,0,1-1.592,1.492,1.39,1.39,0,0,1-1.411-1.492,1.61,1.61,0,0,1,1.592-1.5,1.4,1.4,0,0,1,1.411,1.5",
    transform: "translate(-148.572 -51.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M383.751,119.621a1.615,1.615,0,0,1-1.592,1.492,1.4,1.4,0,0,1-1.411-1.492,1.617,1.617,0,0,1,1.592-1.5,1.4,1.4,0,0,1,1.411,1.5",
    transform: "translate(-165.968 -51.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M330.533,119.621a1.615,1.615,0,0,1-1.592,1.492,1.39,1.39,0,0,1-1.411-1.492,1.61,1.61,0,0,1,1.592-1.5,1.4,1.4,0,0,1,1.411,1.5",
    transform: "translate(-142.77 -51.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M357.142,119.621a1.605,1.605,0,0,1-1.582,1.492,1.39,1.39,0,0,1-1.411-1.492,1.61,1.61,0,0,1,1.592-1.5,1.39,1.39,0,0,1,1.4,1.5",
    transform: "translate(-154.373 -51.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M370.451,119.621a1.614,1.614,0,0,1-1.592,1.492,1.387,1.387,0,0,1-1.4-1.492,1.607,1.607,0,0,1,1.583-1.5,1.4,1.4,0,0,1,1.411,1.5",
    transform: "translate(-160.175 -51.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M353.878,54.02a8.986,8.986,0,0,0-8.841,8.336l-.177,2.935h2.768l.178-2.935a6,6,0,0,1,5.9-5.568,5.186,5.186,0,0,1,5.231,5.569l-.178,2.935h2.769l.177-2.936a7.766,7.766,0,0,0-7.832-8.337",
    transform: "translate(-150.326 -23.548)",
    fill: "#56af5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M361.269,75.94l-.843,13.934a2.169,2.169,0,0,1-2.124,2H340.29a1.811,1.811,0,0,1-1.824-1.948L339.309,76a2.171,2.171,0,0,1,2.124-2.013L359.445,74a1.816,1.816,0,0,1,1.824,1.935",
    transform: "translate(-147.537 -32.253)",
    fill: "#56af5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M358.2,86.546l.567,3.432a.3.3,0,0,1-.324.336h-3.083a.273.273,0,0,1-.283-.336l.982-3.432a1.705,1.705,0,0,1-.665-1.471,1.975,1.975,0,0,1,1.943-1.819,1.693,1.693,0,0,1,1.709,1.819,1.862,1.862,0,0,1-.844,1.471",
    transform: "translate(-154.775 -36.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M0,134.194l.178,41.482a2.088,2.088,0,0,0,2.087,2.083H49.743l13.379,10.93a1.159,1.159,0,0,0,1.894-.9l-.021-10.031h6.692a2.077,2.077,0,0,0,2.078-2.083l-.178-41.482a2.088,2.088,0,0,0-2.087-2.083H2.078A2.077,2.077,0,0,0,0,134.194",
    transform: "translate(0 -57.588)",
    fill: "#ffe033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M8.366,142.649l.159,32.015a1.557,1.557,0,0,0,1.565,1.546H71.137a1.549,1.549,0,0,0,1.559-1.546l-.159-32.015a1.57,1.57,0,0,0-1.565-1.562H9.925a1.563,1.563,0,0,0-1.559,1.562",
    transform: "translate(-3.647 -61.5)",
    fill: "#56af5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M62.735,159.014a7.105,7.105,0,0,0-3.17.746,7.016,7.016,0,0,0-2.231,1.549c-5.061,5.224-8.868,5.231-14.455-.176a6.978,6.978,0,0,0-2.568-1.582,7.133,7.133,0,1,0-.786,13.467,6.685,6.685,0,0,0,3.518-1.978c5.747-5.819,9.588-4.534,14.455.177a6.982,6.982,0,0,0,3.215,1.771,7.132,7.132,0,1,0,2.023-13.974",
    transform: "translate(-13.28 -69.315)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup25);
export default __webpack_public_path__ + "static/media/Group_25.bc6f0a9eca390cf3a427e4666f596caa.svg";
export { ForwardRef as ReactComponent };